import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetCompetitorsVehiclesService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {HttpVehiclesRepository} deps.httpVehiclesRepository
   */
  constructor({config, httpVehiclesRepository}) {
    super()
    this._config = config
    this._repository = httpVehiclesRepository
  }

  @inlineError
  async execute({vehicleEntity}) {
    const [getCompetitorsError, getCompetitorsResponse] = await this._repository.getCompetitors({vehicleEntity})

    if (getCompetitorsError) return Promise.reject(getCompetitorsError)
    return getCompetitorsResponse
  }
}
